// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"pL","category":"pM","tab":"pN","selected":"pO","isRental":"pP"};